function nextStep(st){
  var currentStep = parseInt(st) - 1;

  console.log('currentStep = '+currentStep);

  if(currentStep == 1){
    var anwser_1 = $('input[name="question_1"]:checked').val();
    if(anwser_1 == 'Sunčane'){
      $('input[name="question_6"]').each(function(i, obj) {
          $(this).attr('onchange','nextStep(8)');
      });
    }
  }
  
  $('.quiz-item-question#step-'+currentStep).removeClass('hide');
  $('.quiz-item-question').removeClass('active');
  $('.quiz-item-question#step-'+st).addClass('active');
  $('.current_step').text(st);
   var progress_bar = st * 8.33;
  if(st == 12){
    progress_bar = 100;
    var anwser_1 = $('input[name="question_1"]:checked').val();
    var anwser_2 = $('input[name="question_2"]:checked').val();
    var anwser_3 = $('input[name="question_3"]:checked').val();
    var anwser_4 = Array.from(document.querySelectorAll('input[name="question_4"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
    var anwser_5 = $('input[name="question_5"]:checked').val();
    var anwser_6 = $('input[name="question_6"]:checked').val();
    var anwser_7 = $('input[name="question_7"]:checked').val();
    var anwser_8 = $('input[name="question_8"]').val();
    var anwser_9 = Array.from(document.querySelectorAll('input[name="question_9"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
    var anwser_10 = Array.from(document.querySelectorAll('input[name="question_10"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
    var anwser_11 = Array.from(document.querySelectorAll('input[name="question_11"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
    console.log('Question_1: '+anwser_1);
    console.log('Question_2: '+anwser_2);
    console.log('Question_3: '+anwser_3);
    console.log('Question_4: '+anwser_4);
    console.log('Question_5: '+anwser_5);
    console.log('Question_6: '+anwser_6);
    console.log('Question_7: '+anwser_7);
    console.log('Question_8: '+anwser_8);
    console.log('Question_9: '+anwser_9);
    console.log('Question_10: '+anwser_10);
    console.log('Question_11: '+anwser_11);

    var anwser_1_tag = $('input[name="question_1"]:checked').data('tag');
    var anwser_2_tag = $('input[name="question_2"]:checked').data('tag');
    var anwser_3_tag = $('input[name="question_3"]:checked').data('tag');
    var anwser_4_tag = Array.from(document.querySelectorAll('input[name="question_4"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));
    var anwser_5_tag = $('input[name="question_5"]:checked').data('tag');
    var anwser_6_tag = $('input[name="question_6"]:checked').data('tag');
    var anwser_7_tag = $('input[name="question_7"]:checked').data('tag');
    var anwser_8_tag = $('input[name="question_8"]').data('tag');
    var anwser_9_tag = Array.from(document.querySelectorAll('input[name="question_9"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));
    var anwser_10_tag = Array.from(document.querySelectorAll('input[name="question_10"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));
    var anwser_11_tag = Array.from(document.querySelectorAll('input[name="question_11"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));

    console.log('anwser_5_tag = '+anwser_5_tag+' ---anwser_6_tag = '+anwser_6_tag);
    var tags = [];
    tags.push("Q01 Tags: "+anwser_1_tag);
    tags.push("Q02 shopify--eyewear-frame-material: "+anwser_2_tag);
    tags.push("Q03 shopify--target-gender: "+anwser_3_tag);
    tags.push("Q04 shopify--color-pattern: "+anwser_4_tag);
    var combine_5_6_tag = [];
    if(anwser_5_tag == 'A3' && anwser_6_tag == 'B2'){
      combine_5_6_tag.push('Okruglo lice');
    }
    if((anwser_5_tag == 'A2' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A2' && anwser_6_tag == 'B1')){
      combine_5_6_tag.push('Ovalno lice');
    }
    if((anwser_5_tag == 'A1' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B1')){
       combine_5_6_tag.push('Srcoliko lice');
    }
     if(anwser_5_tag == 'A3' && anwser_6_tag == 'B2'){
      combine_5_6_tag.push('Četvrtasto lice');
    }
    if((anwser_5_tag == 'A2' && anwser_6_tag == 'B1') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B1') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B2')){
      combine_5_6_tag.push('Duguljasto lice');
    }
    if(anwser_5_tag == 'A2' && anwser_6_tag == 'B3'){
      combine_5_6_tag.push('Trouglasto lice');
    }
    if((anwser_5_tag == 'A2' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B1')){
      combine_5_6_tag.push('Dijamantsko lice');
    }
   tags.push("Q05 & 6 Tags: "+combine_5_6_tag);
   tags.push("Q07 Tags: "+anwser_7_tag);
    tags.push("Q08: "+anwser_8_tag);
    tags.push("Q09 Tags: "+anwser_9_tag);
    tags.push("Q010 shopify--shape: "+anwser_10_tag);
    tags.push("Q011 Tags: "+anwser_11_tag);
    console.log(tags);
  }
  $('.quiz-wrapper .process_bar .process_bar_inner').css('width',progress_bar+'%');
  
}

window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
        console.log("Submit Klaviyo Form");
      
        const submittedEmail = e.detail.metaData.$email; 
        var anwser_1 = $('input[name="question_1"]:checked').val();
        var anwser_2 = $('input[name="question_2"]:checked').val();
        var anwser_3 = $('input[name="question_3"]:checked').val();
        var anwser_4 = Array.from(document.querySelectorAll('input[name="question_4"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
        var anwser_5 = $('input[name="question_5"]:checked').val();
        var anwser_6 = $('input[name="question_6"]:checked').val();
        var anwser_7 = $('input[name="question_7"]:checked').val();
        var anwser_8 = $('input[name="question_8"]').val();
        var anwser_9 = Array.from(document.querySelectorAll('input[name="question_9"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
        var anwser_10 = Array.from(document.querySelectorAll('input[name="question_10"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
        var anwser_11 = Array.from(document.querySelectorAll('input[name="question_11"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);

        var anwser_1_tag = $('input[name="question_1"]:checked').data('tag');
        var anwser_2_tag = $('input[name="question_2"]:checked').data('tag');
        var anwser_3_tag = $('input[name="question_3"]:checked').data('tag');
        var anwser_4_tag = Array.from(document.querySelectorAll('input[name="question_4"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));
        var anwser_5_tag = $('input[name="question_5"]:checked').data('tag');
        var anwser_6_tag = $('input[name="question_6"]:checked').data('tag');
        var anwser_7_tag = $('input[name="question_7"]:checked').data('tag');
        var anwser_8_tag = $('input[name="question_8"]').data('tag');
        var anwser_9_tag = Array.from(document.querySelectorAll('input[name="question_9"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));
        var anwser_10_tag = Array.from(document.querySelectorAll('input[name="question_10"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));
        var anwser_11_tag = Array.from(document.querySelectorAll('input[name="question_11"]')).filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.getAttribute('data-tag'));
    
        var tags = [];
        tags.push("Q01 Tags: "+anwser_1_tag);
        tags.push("Q02 shopify--eyewear-frame-material: "+anwser_2_tag);
        tags.push("Q03 shopify--target-gender: "+anwser_3_tag);
        tags.push("Q04 shopify--color-pattern: "+anwser_4_tag);
        var combine_5_6_tag = [];
        if(anwser_5_tag == 'A3' && anwser_6_tag == 'B2'){
          combine_5_6_tag.push('Okruglo lice');
        }
        if((anwser_5_tag == 'A2' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A2' && anwser_6_tag == 'B1')){
          combine_5_6_tag.push('Ovalno lice');
        }
        if((anwser_5_tag == 'A1' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B1')){
           combine_5_6_tag.push('Srcoliko lice');
        }
         if(anwser_5_tag == 'A3' && anwser_6_tag == 'B2'){
          combine_5_6_tag.push('Četvrtasto lice');
        }
        if((anwser_5_tag == 'A2' && anwser_6_tag == 'B1') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B1') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B2')){
          combine_5_6_tag.push('Duguljasto lice');
        }
        if(anwser_5_tag == 'A2' && anwser_6_tag == 'B3'){
          combine_5_6_tag.push('Trouglasto lice');
        }
        if((anwser_5_tag == 'A2' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B3') || (anwser_5_tag == 'A1' && anwser_6_tag == 'B1')){
          combine_5_6_tag.push('Dijamantsko lice');
        }
        tags.push("Q05 & 6 Tags: "+combine_5_6_tag);
        tags.push("Q07 Tags: "+anwser_7_tag);
        tags.push("Q08: "+anwser_8_tag);
        tags.push("Q09 Tags: "+anwser_9_tag);
        tags.push("Q010 shopify--shape: "+anwser_10_tag);
        tags.push("Q011 Tags: "+anwser_11_tag);
      
      //Track events for an identified user
      
      //Identify a user
      klaviyo.identify({
        'email' : submittedEmail
      });

      klaviyo.identify({
        'Question_1' : anwser_1,
        'Question_2' : anwser_2,
        'Question_3' : anwser_3,
        'Question_4' : anwser_4,
        'Question_5' : anwser_5,
        'Question_6' : anwser_6,
        'Question_7' : anwser_7,
        'Question_8' : anwser_8,
        'Question_9' : anwser_9,
        'Question_10' : anwser_10,
        'Question_11' :anwser_11,
        'Tags_Metafields': tags
      });

     
      klaviyo.track('Quiz Submmited', {
        'Question_1' : anwser_1,
        'Question_2' : anwser_2,
        'Question_3' : anwser_3,
        'Question_4' : anwser_4,
        'Question_5' : anwser_5,
        'Question_6' : anwser_6,
        'Question_7' : anwser_7,
        'Question_8' : anwser_8,
        'Question_9' : anwser_9,
        'Question_10' : anwser_10,
        'Question_11' :anwser_11,
        'Tags_Metafields': tags
      });
    
    }
});
